import { Activity, CircleDollarSign, LogOut, UserRound } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Logo } from "./Logo";

export function MemberLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const signOut = async () => {
    await logout();
    navigate("/");
  };
  return (
    <div className="member-shell">
      <header className="member-header">
        <Logo />
        <nav className="desktop-nav" aria-label="Member navigation">
          <NavLink to="/earn">Earn</NavLink>
          <NavLink to="/activity">Activity</NavLink>
          <NavLink to="/cash-out">Cash out</NavLink>
          <NavLink to="/account">Account</NavLink>
        </nav>
        <button className="icon-button desktop-logout" type="button" onClick={signOut} aria-label="Log out">
          <LogOut size={19} />
        </button>
      </header>
      <main className="member-main">
        <Outlet />
      </main>
      <nav className="bottom-nav" aria-label="Member navigation">
        <NavLink to="/earn"><CircleDollarSign /><span>Earn</span></NavLink>
        <NavLink to="/activity"><Activity /><span>Activity</span></NavLink>
        <NavLink to="/cash-out"><span className="cash-symbol">$</span><span>Cash out</span></NavLink>
        <NavLink to="/account"><UserRound /><span>Account</span></NavLink>
      </nav>
    </div>
  );
}
